"use client";

import { useEffect, useRef, useState } from "react";
import GoogleMapsAutoComplete, {
    useGooglePlace,
} from "../themed/GoogleMapsAutoComplete";
import { EventsNearInputProps } from "../themed/SearchInput";

export const EventsNearInput = (props: EventsNearInputProps) => {
    const [googlePlace, setGooglePlace] = useGooglePlace();
    const { onLocationChange, ...inputProps } = props;
    const [placeholderValue, setPlaceholderValue] = useState<string>(
        props.placeholder || "",
    );

    useEffect(() => {
        if (!googlePlace || !googlePlace.formatted_address) return;
        setPlaceholderValue(googlePlace.formatted_address);
        props.onLocationChange(googlePlace);
    }, [googlePlace]);

    return (
        <GoogleMapsAutoComplete
            value={googlePlace}
            setValue={setGooglePlace}
            className={props.className}
            placeholder={placeholderValue}
            label={false}
        />
    );
};
